import Skeleton from '@carvana/ds-skeleton';
import cx from 'classnames';
import { Fragment } from 'react';
import { DividerLine, LinkCardLoadingContainer } from './LinkCards.styles';

export enum LinkCardType {
  VDP = 'vdp',
  SRP = 'srp'
}

type OwnProps = {
  card: LinkCardType;
};

function VDPSkeleton() {
  return (
    <div className="flex h-[91px] w-full items-center justify-between gap-2xl first:pt-0 last:pb-0 sm:h-[102px]">
      {/* Text Content */}
      <div className="flex w-full flex-col gap-sm sm:gap-md">
        <Skeleton width={57} className="!h-[16px] md:!h-[18px]" />
        <Skeleton width="90%" className="!h-[16px] md:!h-[18px]" />
        <Skeleton width="90%" className="!h-[16px] md:!h-[18px]" />
        <Skeleton width={65} className="!h-[16px] md:!h-[18px]" />
      </div>
      {/* Vehicle Image */}
      <Skeleton className="!h-[67px] !w-[90px] shrink-0 md:!h-full md:!w-[140px]" />
    </div>
  );
}

function SRPSkeleton() {
  return (
    <div className="flex min-h-[71px] w-full flex-col justify-center gap-md py-md">
      <Skeleton height={18} width="66%" />
      <div className="flex gap-md">
        <Skeleton height={18} width={66} />
        <Skeleton height={18} width={51} />
      </div>
    </div>
  );
}

export default function LinksLoadingCard({ card }: OwnProps) {
  const isVdp = card === LinkCardType.VDP;
  const cards = Array.from({ length: isVdp ? 3 : 4 }, (_, i) => i);

  return (
    <LinkCardLoadingContainer
      aria-busy="true"
      aria-label="Loading recommendations"
      aria-live="polite"
      data-testid="links-loading-card"
      role="status"
    >
      <div className="flex items-center justify-between">
        <Skeleton height={24} width={128} className="shrink-0" />
        <Skeleton height={16} width={80} />
      </div>
      <div
        className={cx('flex flex-1 flex-col justify-between', {
          'pb-[2px] sm:gap-lg sm:pb-[3px] md:pb-[5px]': isVdp
        })}
      >
        {cards.map((_, i) =>
          isVdp ? (
            <Fragment key={i}>
              {i !== 0 && <DividerLine />}
              <VDPSkeleton />
            </Fragment>
          ) : (
            <Fragment key={i}>
              {i !== 0 && <DividerLine />}
              <SRPSkeleton />
            </Fragment>
          )
        )}
      </div>
    </LinkCardLoadingContainer>
  );
}
